import { NgModule }     from '@angular/core';

import { GoogleSsoOneTapComponent } from './google-sso.one-tap.component';
import { GoogleSsoSignInComponent } from './google-sso.sign-in.component';
import { MessagesModule }           from '../../app-lite/messages/messages.module';
import { SharedModule }             from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    GoogleSsoOneTapComponent,
    GoogleSsoSignInComponent
  ],
  entryComponents: [
    GoogleSsoOneTapComponent,
    GoogleSsoSignInComponent
  ],
  exports: [
    GoogleSsoOneTapComponent,
    GoogleSsoSignInComponent
  ],
  imports: [
    MessagesModule,
    SharedModule
  ]
})
export class GoogleSsoModule {}
